import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  Scorecard,
  ScorecardsActionStoreArgument,
} from 'store/interfaces';
import api from 'api';
import { API_SCORECARD_FEEDBACK_VISIBILITY } from 'constants/api';
import { generateURL } from 'helpers';
import { updateFullData } from './updateFullData';

export const setFeedbackVisibility = createAsyncThunk<
  Scorecard,
  {
    id: number;
    feedbackGoalId: number;
    hidden: boolean;
    store: ScorecardsActionStoreArgument;
  }
>(
  'scorecards/setFeedbackVisibility',
  async ({ id, feedbackGoalId, hidden, store }, thunkAPI) =>
    api.axios
      .patch<Scorecard>(
        generateURL(API_SCORECARD_FEEDBACK_VISIBILITY, {
          id,
          feedbackGoalId,
        }),
        { hidden },
      )
      .then((res) => {
        thunkAPI.dispatch(updateFullData({ id, store }));
        return res.data;
      })
      .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
